var Backbone = require("../../libs/backbone/backbone");
var GenericModel = require("./generic.model.ts");

var AgentsModel = GenericModel.extend(
{
    urlRoot : '/rest/api/users',
    id : null,
    name : "",
    lastName : "",
    userName : "",
    email : "",
    privilegeLevel : ""
});

module.exports = AgentsModel;